module.exports = __webpack_public_path__ + "static/img/FITmenu07.d5f6700.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu07.png
// module id = hlBM
// module chunks = 1